// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format4 } from '../../constants';

import { format2 } from '../../constants';

/** Liechtenstein */
const LI: PhoneNumberData = [423, 'LI', 7, format4, 9, format2];

export default LI;
